import clsx from "clsx";
import React from "react";

interface LanderQuizButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isSelected: boolean;
  isCorrect: boolean;
  onClickOption: () => void;
}

export const LanderQuizButton: React.FC<LanderQuizButtonProps> = ({
  ...props
}) => (
  <button
    className={clsx(
      "lander-quiz--button",
      props.isSelected && props.isCorrect && "lander-quiz--button-correct",
      props.isSelected &&
        !props.isCorrect &&
        "lander-quiz--button-incorrect"
    )}
    onClick={props.onClickOption}
    {...props}
  >
    {props.children}
  </button>
);
